module.exports = __webpack_public_path__ + "media/src/images/unknown_board-579f5a7bcbb7f31aaf29e1f26082d415.png";